import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
// Mui
import { Box, Typography } from '@mui/material';
// Icons
import { Warning as WarningIcon } from '@mui/icons-material';

const InternalServerErrorContent:FC = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Box
        sx={{
          width: 128,
          height: 128,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '1px solid rgba(0,0,0,0.08)',
          borderRadius: '50%',
          bgcolor: 'white',
          mx: 'auto',
          mb: 4
        }}
      ><WarningIcon color="disabled" fontSize="large" /></Box>
      <Typography sx={{ mb: 4 }} variant="h5">{t('notifications.requests.internalServerError.title')}</Typography>
      <Typography sx={{ mb: 4 }} variant="body1">{t('notifications.requests.internalServerError.content')}</Typography>
    </Fragment>
  )
}

export default InternalServerErrorContent;
